import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ResizeAware from 'react-resize-aware';
import Slider from 'react-rangeslider';
import uuid from 'uuid/v4';
import { isEmpty } from 'lodash';
import { CROSSTAB_VIEWER_GRID_TYPE } from '../../../util/CrosstabUtils';

import * as crosstabActions from '../../../actions/crosstabActions';

import CrosstabViewerGridHeadRow from './CrosstabViewerGridHeadRow';
import CrosstabViewerGridBodyRows from './CrosstabViewerGridBodyRows';

import saveFolderIcon from '../../../images/save-to-cloud-icon_white.png';
// import clearPrivateEyeButton from '../../../images/clear-field-icon_white.png';
import sampleDarkBlueIcon from '../../../images/sample-icon_darkblue.png';
import weightedDarkBlueIcon from '../../../images/weighted-icon_darkblue.png';
import verticalDarkBlueIcon from '../../../images/vertical-icon-down_darkblue.png';
import horizontalDarkBlueIcon from '../../../images/horizontal-icon_darkblue.png';
import indexDarkBlueIcon from '../../../images/index-icon_darkblue.png';
import { toastWarning } from '../../../util/toastUtils';
import GridInfoBox from '../../common/EnhancedGridFeature/GridInfoBox';
import infoIcon from '../../../images/announcement_icon.svg';
// import { stat } from 'fs';

class CrosstabViewerGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crosstabViewerGridContainerWidth: 'inherit',
      crosstabTitle: '',
        // props.tableData && props.tableData.title ? props.tableData.title : '',
      sliderVerticalValue: props.verticalPageNo + 1,
      sliderHorizontalValue: props.horizontalPageNo + 1,
    };
  }

  UNSAFE_componentWillMount() {
    const { loadedCrosstabInfo } = this.props;
    const crosstabTitle = loadedCrosstabInfo.tableTitle;
    this.setState({ crosstabTitle });
  }

  componentDidMount() {
    this.props.stopSpinner();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.tableData
      && (nextProps.loadedCrosstabInfo.title !== this.state.crosstabTitle)
    ) {
      this.setState({ crosstabTitle: nextProps.loadedCrosstabInfo.tableTitle });
    }

    if (
      this.props.tableData !== nextProps.tableData ||
      this.props.viewerGridType !== nextProps.viewerGridType ||
      this.props.cellElementList !== nextProps.cellElementList
    ) {
      this.props.stopSpinner();
      if (
        this.crosstabViewerGridContainer &&
        this.bodyContainer &&
        this.crosstabViewerGridHeadContainer
      ) {
        let tempScrollLeftPos = this.crosstabViewerGridContainer.scrollLeft;
        if (
          this.crosstabViewerGridContainer.scrollWidth -
          this.crosstabViewerGridContainer.offsetWidth ===
          tempScrollLeftPos
        ) {
          tempScrollLeftPos = this.crosstabViewerGridContainer.scrollWidth;
        }
        this.bodyContainer.style.marginRight = 0;
        this.crosstabViewerGridHeadContainer.style.marginRight = 0;
        this.crosstabViewerGridContainer.scrollLeft = 0;
        this.crosstabViewerGridContainer.scrollLeft = tempScrollLeftPos;
      }
      if (this.bodyContainer) {
        this.bodyContainer.scrollTop = 0;
      }
    }
    // if (
    //   nextProps.tableData &&
    //   nextProps.tableData.title !== this.state.crosstabTitle
    // ) {
    //   this.setState({ crosstabTitle: nextProps.tableData.title });
    // }

    if (this.props.verticalPageNo !== nextProps.verticalPageNo) {
      this.setState(() => ({
        sliderVerticalValue: nextProps.verticalPageNo + 1,
      }));
    }

    if (this.props.horizontalPageNo !== nextProps.horizontalPageNo) {
      this.setState(() => ({
        sliderHorizontalValue: nextProps.horizontalPageNo + 1,
      }));
    }
  }

  componentDidUpdate() {
    if (this.crosstabViewerGridBodyTable && this.crosstabViewerGridHeadTable) {
      this.crosstabViewerGridBodyTable.style.width = `${
        this.crosstabViewerGridHeadTable.clientWidth
        }px`;
    }
  }

  onVerticalScroll = event => {
    let delta;
    if (event.wheelDelta) {
      delta = event.wheelDelta;
    } else {
      delta = -1 * event.deltaY;
    }
    if (delta < 0) {
      this.gotoDown();
    } else if (delta > 0) {
      this.gotoUp();
    }
  };

  getCrosstabIcon = name => {
    let icon;
    switch (name) {
      case 'sample':
        icon = sampleDarkBlueIcon;
        break;
      case 'weighted':
        icon = weightedDarkBlueIcon;
        break;
      case 'vertical':
        icon = verticalDarkBlueIcon;
        break;
      case 'horizontal':
        icon = horizontalDarkBlueIcon;
        break;
      case 'index':
        icon = indexDarkBlueIcon;
        break;
      default:
        icon = sampleDarkBlueIcon;
        break;
    }
    return icon;
  };

  getCrosstabTitle = () => this.state.crosstabTitle;

  handleCrosstabTitleChange = e => {
    if (e.target.value.length === 0 || e.target.value.trim()) {
      this.setState({ crosstabTitle: e.target.value });
    }
  };

  handleCrosstabTitleBlur = () => {
    // this.setState({ crosstabTitle: e.target.value });
    const { crosstabTitle } = this.state;
    const { loadedCrosstabInfo } = this.props;
    this.props.crosstabActions.saveCrosstabTableTitle({
      ...loadedCrosstabInfo,
      title: crosstabTitle,
    });
  };

  handleSaveButton = () => {
    const { crosstabTitle } = this.state;
    this.props.handleCrosstabSaveButton(crosstabTitle);
  };

  handleCrosstabViewerGridContainerResize = dimensions => {
    this.setState({ crosstabViewerGridContainerWidth: dimensions.width });
  };

  rowHeaders = rowList => {
    if (this.props.viewerGridType !== CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE) {
      const rowHeader2 = (
        <td ref={node => (this.iconList = node)}>
          {this.props.cellElementList.map(item =>
            item.isVisible &&
              (this.props.viewerGridType !== CROSSTAB_VIEWER_GRID_TYPE.TREND ||
                item.isTrendVisibility) ? (
                <div
                  key={item.key}
                  title={
                    item.key === 'vertical' || item.key === 'horizontal'
                      ? `${item.key.toUpperCase()} %`
                      : item.key.toUpperCase()
                  }
                >
                  <img
                    alt={item.key}
                    src={this.getCrosstabIcon(item.key)}
                    className="labelIcon"
                  />
                </div>
              ) : (
                ''
              ),
          )}
        </td>
      );
      const lastRenderedRow =
        this.props.verticalPageNo + this.props.verticalEPP < rowList.length
          ? this.props.verticalPageNo + this.props.verticalEPP
          : rowList.length;
      return rowList
        .slice(this.props.verticalPageNo, lastRenderedRow)
        .map(row => (
          <tr key={uuid()}>
            <td
              data-tooltip
              aria-haspopup="true"
              title={`${row.tooltipVal ? row.tooltipVal : row.rowHeader} ${
                row.isRowLabelUpdated ? String.fromCharCode(185) : ''
                }`}
              data-line-clamp={
                this.iconList ? this.iconList.children.length : 2
              }
            >
              <div>
                {this.checkDDNHCS(row.rowHeader) ? `${String.fromCharCode(10020)} ${row.rowHeader}` : row.rowHeader}
                <sup>{row.isRowLabelUpdated ? '1' : ''}</sup>
                {row.footnotes && row.footnotes.length > 0 && <GridInfoBox
                  Positions={['bottom', 'right']}
                  InfoBoxButtonInner={<img
                    src={infoIcon}
                    alt="Footnote Icon" title="" />}
                  Align="start"
                  containerClassName="mrc-accredited-popover"
                  btnWidth="20px"
                  footNotes={row.footnotes ? row.footnotes : []}
                  footNoteList={this.props.crosstabFootNotes}
                />}
              </div>
            </td>
            {rowHeader2}
          </tr>
        ));
    }
    const lastRenderedRow =
      this.props.verticalPageNo + this.props.verticalEPP < rowList.length
        ? this.props.verticalPageNo + this.props.verticalEPP
        : rowList.length;
    return rowList
      .slice(this.props.verticalPageNo, lastRenderedRow)
      .map(row => (
        <tr key={uuid()}>
          <td
            data-tooltip
            aria-haspopup="true"
            title={`${row.tooltipVal ? row.tooltipVal : row.rowHeader} ${
              row.isRowLabelUpdated ? String.fromCharCode(185) : ''
              }`}
            data-line-clamp={
              this.iconList ? this.iconList.children.length : 2
            }
          >
            <div>
              {this.checkDDNHCS(row.rowHeader) ? `${String.fromCharCode(10020)} ${row.rowHeader}` : row.rowHeader}
              <sup>{row.isRowLabelUpdated ? '1' : ''}</sup>
            </div>
          </td>
        </tr>
      ));
  };

  handleVerticalChange = value => this.props.setVerticalPage(value);

  handleHorizontalChange = value => this.props.setHorizontalPage(value);

  handleVerticalChangeComplete = () =>
    this.props.setVerticalPage(this.state.sliderVerticalValue);

  handleHorizontalChangeComplete = () =>
    this.props.setHorizontalPage(this.state.sliderHorizontalValue);

  gotoPrev = () =>
    this.props.setHorizontalPage(
      this.state.sliderHorizontalValue > 1
        ? this.state.sliderHorizontalValue - 1
        : 1,
    );

  gotoNext = () =>
    this.props.setHorizontalPage(
      this.state.sliderHorizontalValue < this.props.horizontalTotalPages
        ? this.state.sliderHorizontalValue + 1
        : this.props.horizontalTotalPages,
    );

  gotoUp = () =>
    this.props.setVerticalPage(
      this.state.sliderVerticalValue > 1
        ? this.state.sliderVerticalValue - 1
        : 1,
    );

  gotoDown = () =>
    this.props.setVerticalPage(
      this.state.sliderVerticalValue < this.props.verticalTotalPages
        ? this.state.sliderVerticalValue + 1
        : this.props.verticalTotalPages,
    );

  checkDDNHCS(val) {
    const { selectedKPIsTitle, allSelectedKPIsInfo } = this.props;
    let ddNHCS = false;
    for (const key in selectedKPIsTitle) {
      if (
        selectedKPIsTitle[key].trim() === val.trim() &&
        allSelectedKPIsInfo[key] &&
        allSelectedKPIsInfo[key].modeled
      ) {
        ddNHCS = allSelectedKPIsInfo[key].modeled;
      }
    }
    return ddNHCS;
  }

  renderColumnsDropdown = () => (
    <div className="trend-grid-dropdown-wrapper">
      <button
        type="button"
        className="button save-button save-trend-button small margin-0"
        onClick={this.handleSaveButton}
        title="Save Trend"
      >
        <img src={saveFolderIcon} alt="Save Trend Name Button" />
      </button>
      <select
        value={this.props.tableData.selectedDropdownColumn}
        onChange={e => this.props.handleColumnDropdown(Number(e.target.value))}
      >
        {this.props.columnDefinitions.map((column, index) => (
          <option
            value={index}
            key={index}
            data-tooltip
            aria-haspopup="true"
            title={`${column.tooltipVal ? column.tooltipVal : column.label} ${
              column.isColumnLabelUpdated ? String.fromCharCode(185) : ''
              }`}
          >
            {this.checkDDNHCS(column.label) ? `${String.fromCharCode(10020)} ${column.label}` : (column.label)}
            {column.isColumnLabelUpdated ? String.fromCharCode(185) : ''}
          </option>
        ))}
      </select>
    </div>
  );

  render() {
    const { tableData, verticalTotalPages, horizontalTotalPages, selectedBaseID, selectedBaseIndex } = this.props;
    if (
      !(
        tableData &&
        tableData.crosstabPerStudy &&
        tableData.crosstabPerStudy[0][tableData.selectedBase] &&
        tableData.crosstabPerStudy[0][tableData.selectedBase].rowList &&
        tableData.crosstabPerStudy[0][tableData.selectedBase].rowList.length > 0
      )
    ) {
      if (this.props.renderEmpty) {
        return this.props.renderEmpty();
      }
    }
    let selectedIndex = 0;
    const { crosstabPerStudy } = tableData;
    let newRowsList = crosstabPerStudy[0][selectedBaseIndex];
    if (!isEmpty(crosstabPerStudy[0])) {
      crosstabPerStudy[0].forEach((keys, index) => {
        if (keys.idKey === selectedBaseID || keys.filter === selectedBaseID) {
          newRowsList = crosstabPerStudy[0][index];
          selectedIndex = index;
        }
      });
    }

    return (
      <ResizeAware
        style={{ position: 'relative', width: '100%' }}
        onlyEvent
        onResize={this.handleCrosstabViewerGridContainerResize}
      >
        <div
          id="crosstabViewerGrid-container"
          className="crosstabViewerGrid-container medium-collapse large-collapse"
          style={{
            width: `${this.state.crosstabViewerGridContainerWidth}px`,
            visibility:
              this.state.crosstabViewerGridContainerWidth === 0
                ? 'hidden'
                : 'visible',
          }}
        >
          {/* <div className="clear-private-eye-button">
            <button onClick={this.props.clearData}>
              <img src={clearPrivateEyeButton} alt="clear private eye button" title="Clear All" />
            </button>
          </div> */}
          <div
            className={`vertical-headers-wrapper ${
              this.props.viewerGridType ===
                CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE
                ? 'w1'
                : 'w2'
              } ${
              this.props.viewerGridType === CROSSTAB_VIEWER_GRID_TYPE.TREND
                ? 'w3'
                : ''
              }`}
            ref={n => (this.rowHeaderGridContainer = n)}
          >
            <div className="top-left">
              {this.props.viewerGridType === CROSSTAB_VIEWER_GRID_TYPE.TREND ? (
                this.renderColumnsDropdown()
              ) : (
                  <div>
                    <div className="inputBox clearfix">
                      <input
                        type="text"
                        placeholder="Enter Crosstab Name"
                        onChange={this.handleCrosstabTitleChange}
                        onBlur={this.handleCrosstabTitleBlur}
                        value={this.state.crosstabTitle}
                      />
                      <button
                        type="button"
                        className="button save-button"
                        onClick={() => {
                          if (this.state.crosstabTitle) {
                            this.handleSaveButton();
                          } else {
                            toastWarning('Please enter crosstab name to save');
                          }
                        }}
                        title="Save"
                      >
                        <img
                          src={saveFolderIcon}
                          alt="Save Crosstab Name Button"
                        />
                      </button>
                    </div>
                    <div className="highlightAndFilter">
                      <div className="margin-lr15">
                        <div className="toggle-bg">
                          <input
                            id="toggle-on"
                            onClick={() => this.props.highlightModal.show()}
                            className="toggle-hnf toggle-left"
                            name="toggle-hnf"
                            type="radio"
                          />
                          <label
                            htmlFor="toggle-on"
                            className="btn-hnf highlight-off"
                            title="Highlight &amp; Filter"
                          >
                            &nbsp;
                        </label>
                          <input
                            id="toggle-off"
                            onClick={() => this.props.highlightRadioButton(false)}
                            className="toggle-hnf toggle-right"
                            name="toggle-hnf"
                            type="radio"
                            defaultChecked
                          />
                          <label
                            htmlFor="toggle-off"
                            className="btn-hnf highlight-on"
                            title="Reset Highlight &amp; Filter"
                          >
                            &nbsp;
                        </label>
                        </div>
                        {/* <div className="clear-all-hnf" onClick={this.props.clearData}
                      title="Clear All">
                      Clear All
                    </div> */}
                      </div>
                    </div>
                  </div>
                )}
            </div>
            <div>
              <table className="crosstabViewerGrid-body unstriped">
                <tbody>
                  {this.rowHeaders(newRowsList.rowList)}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className={`crosstabViewerGrid-content-wrapper ${
              this.props.viewerGridType ===
                CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE
                ? 'wc1'
                : 'wc2'
              } ${
              this.props.viewerGridType === CROSSTAB_VIEWER_GRID_TYPE.TREND
                ? 'wc3'
                : ''
              }`}
            ref={n => (this.crosstabViewerGridContainer = n)}
            onScroll={() => {
              this.bodyContainer.style.marginRight = `${this
                .crosstabViewerGridContainer.scrollLeft * -1}px`;
              this.crosstabViewerGridHeadContainer.style.marginRight = `${this
                .crosstabViewerGridContainer.scrollLeft * -1}px`;
            }}
          >
            <div className="custom-horizontal-scrollbar-wrapper">
              <button
                type="button"
                className="scroll-button horizontal-left"
                onClick={this.gotoPrev}
              >
                &nbsp;
              </button>
              <Slider
                min={1}
                max={horizontalTotalPages}
                value={this.state.sliderHorizontalValue}
                orientation="horizontal"
                tooltip={false}
                onChange={this.handleHorizontalChange}
                onChangeComplete={this.handleHorizontalChangeComplete}
              />
              <button
                type="button"
                className="scroll-button horizontal-right"
                onClick={this.gotoNext}
              >
                &nbsp;
              </button>
            </div>
            <div
              className="crosstabViewerGrid-headContainer"
              ref={node => (this.crosstabViewerGridHeadContainer = node)}
            >
              <table
                className="crosstabViewerGrid-head unstriped"
                ref={node => (this.crosstabViewerGridHeadTable = node)}
              >
                <CrosstabViewerGridHeadRow
                  {...this.props}
                  selectedDropdownColumn={
                    this.props.tableData.selectedDropdownColumn
                  }
                  ddNHCSReportsList={this.props.ddNHCSReportsList}
                  selectedKPIsTitle={this.props.selectedKPIsTitle}
                  allSelectedKPIsInfo={this.props.allSelectedKPIsInfo}
                />
              </table>
            </div>
            <div
              className="crosstabViewerGrid-bodyContainer"
              ref={node => (this.bodyContainer = node)}
              onScroll={() => {
                // this.rowHeaderGridContainer.scrollTop = this.bodyContainer.scrollTop;
              }}
              onWheel={event => {
                this.onVerticalScroll(event);
              }}
            >
              <div>
                <div className="custom-vertical-scrollbar-wrapper">
                  <button
                    type="button"
                    className="scroll-button vertical-top"
                    onClick={this.gotoUp}
                  >
                    &nbsp;
                  </button>
                  <Slider
                    min={1}
                    max={verticalTotalPages}
                    value={this.state.sliderVerticalValue}
                    orientation="vertical"
                    tooltip={false}
                    reverse
                    onChange={this.handleVerticalChange}
                    onChangeComplete={this.handleVerticalChangeComplete}
                  />
                  <button
                    type="button"
                    className="scroll-button vertical-bottom"
                    onClick={this.gotoDown}
                  >
                    &nbsp;
                  </button>
                </div>
              </div>
              <div style={{ position: 'relative' }}>
                <table
                  className="crosstabViewerGrid-body unstriped"
                  ref={node => (this.crosstabViewerGridBodyTable = node)}
                >
                  <CrosstabViewerGridBodyRows
                    {...this.props}
                    selectedDropdownColumn={
                      this.props.tableData.selectedDropdownColumn
                    }
                    ddNHCSReportsList={this.props.ddNHCSReportsList}
                    selectedKPIsTitle={this.props.selectedKPIsTitle}
                    allSelectedKPIsInfo={this.props.allSelectedKPIsInfo}
                    selectedIndex={selectedIndex}
                  />
                </table>
              </div>
            </div>
          </div>
        </div>
      </ResizeAware>
    );
  }
}

CrosstabViewerGrid.propTypes = {
  horizontalPageNo: PropTypes.number,
  verticalTotalPages: PropTypes.number,
  horizontalTotalPages: PropTypes.number,
  verticalPageNo: PropTypes.number,
  verticalEPP: PropTypes.number,
  tableData: PropTypes.shape({
    selectedDropdownColumn: PropTypes.number,
    title: PropTypes.string,
  }),
  columnDefinitions: PropTypes.arrayOf(PropTypes.object),
  viewerGridType: PropTypes.oneOf(Object.values(CROSSTAB_VIEWER_GRID_TYPE)),
  cellElementList: PropTypes.arrayOf(PropTypes.shape({})),
  highlightModal: PropTypes.shape({
    show: PropTypes.func,
  }),
  renderEmpty: PropTypes.func,
  highlightRadioButton: PropTypes.func,
  handleColumnDropdown: PropTypes.func,
  handleCrosstabSaveButton: PropTypes.func,
  setVerticalPage: PropTypes.func,
  setHorizontalPage: PropTypes.func,
  stopSpinner: PropTypes.func,
  ddNHCSReportsList: PropTypes.arrayOf(PropTypes.object),
  selectedKPIsTitle: PropTypes.shape({}),
  allSelectedKPIsInfo: PropTypes.shape({}),
  loadedCrosstabInfo: PropTypes.shape({}),
  crosstabActions: PropTypes.shape({
    saveCrosstabTableTitle: PropTypes.func,
  }),
  crosstabFootNotes: PropTypes.shape({}),
};

CrosstabViewerGrid.defaultProps = {
  renderEmpty: () => <div />,
};

function mapStateToProps(state) {
  return {
    ddNHCSReportsList: state.crosstab.ddNHCSReportsList,
    selectedKPIsTitle: state.crosstab.selectedKPIsTitle,
    allSelectedKPIsInfo: state.crosstab.allSelectedKPIsInfo,
    loadedCrosstabInfo: state.crosstab.loadedCrosstabInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(CrosstabViewerGrid);
